/**
 * Probe 이력의 행 모델.
 *
 * 정렬 키가 되는 값만 public 으로 노출한다 — c6 `DataTable` 의 컬럼 key 는 행의 public 필드에서
 * 고르고 기본 `compare` 가 그 값을 그대로 비교한다. 선택은 행 선택(selection)이 아니라 **current**
 * 축이라 `canSelect` 는 거짓이다 — c6 가 둘을 독립으로 분리해 둔 계약을 그대로 쓴다.
 *
 * Owns:
 * - 행 식별 · 클릭 활성화, 목록 셀이 읽는 파생 값.
 *
 * Does not own:
 * - 조회 — 페이지. 상태 문구 · 색 — `feature/probeStatus.ts`.
 */
import { TableRow } from "@carbon6/c6-frontend-design";
import type { Probe, ProbeState } from "../domain/probe";

export type ProbeRowOptions = {
  onOpen: (probeUuid: string) => void;
};

export class ProbeTableRow extends TableRow {
  readonly uuid: string;
  readonly state: ProbeState;
  readonly episodeTarget: number;
  readonly createdAtMs: number;
  /** 확정된 revision 의 식별자. 아직 없으면 빈 문자열이라 정렬에서 뒤로 가지 않는다. */
  readonly revisionIdentifier: string;
  /** 고른 episode 수. 아직 고르지 않았으면 `null` — `0`(고른 것이 없음)과 다른 뜻이다. */
  readonly selectedCount: number | null;

  private readonly onOpen: (probeUuid: string) => void;

  constructor(probe: Probe, { onOpen }: ProbeRowOptions) {
    super();
    this.uuid = probe.uuid;
    this.state = probe.state;
    this.episodeTarget = probe.episodeTarget;
    this.createdAtMs = probe.createdAtMs;
    this.revisionIdentifier = probe.revision?.identifier ?? "";
    this.selectedCount = probe.selectedSourceIds?.length ?? null;
    this.onOpen = onOpen;
  }

  override getRowId(): string {
    return this.uuid;
  }

  override canShow(): boolean {
    return true;
  }

  /** 선택 축이 아니라 current 축을 쓴다 — 여러 건을 골라 하는 명령이 없다. */
  override canSelect(): boolean {
    return false;
  }

  override get isRowClickable(): boolean {
    return true;
  }

  override onRowClick(): void {
    this.onOpen(this.uuid);
  }
}
